import { OmrState } from './state';

export const getters = {
    uploadImageState: (state: OmrState) => state.uploadImageState,
    uploadImageList: (state: OmrState) => state.uploadImageState.img_list,
    autoShowStatementDialog: (state: OmrState) => state.autoShowStatementDialog,
};
